module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', _vm._l((_vm.statePath), function(state) {
    return _c('form-question', {
      key: state,
      ref: "question",
      refInFor: true,
      staticClass: "light-frame",
      attrs: {
        "question": _vm.questions[state.qid],
        "values": _vm.values,
        "value": _vm.values[state.qid],
        "error-message": _vm.errorMessage(state.qid)
      },
      on: {
        "answer-value": function($event) {
          return _vm.nextState(state, $event)
        }
      }
    })
  }), 1), _vm._v(" "), (_vm.transitionToScreen != null) ? _c('div', {
    staticClass: "centered-child"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Please correct the mistakes before ")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1687b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Screen.vue
// module id = 726
// module chunks = 3